module.exports = __webpack_public_path__ + "static/design-088c5915fe9e592ad393c53d302d25b2.webp";